import React, { useState, useEffect } from "react";
import styles from "./Contactusform.module.scss";

let Alert = ({ message, type = 'success' }) => {
    return (
        <div style={{
            display: 'block',
            width: '100%',
            background: type === 'success' ? 'rgba(0, 255, 0, 0.2)' : 'rgba(255, 0, 0, 0.2)',
            color: 'black',
            padding: '1rem',
            margin: '0.5rem',
            borderRadius: '10px',
            boxShadow: '0px 4px 10px rgba(0,0,0,0.1)'
        }}>
            {message ? message : ('The World Needs more `Lerts')}
        </div>
    )
}

const Contactusform = () => {
    const [contactName, setContactName] = useState('')
    const [contactEmail, setContactEmail] = useState('')
    const [contactPhone, setContactPhone] = useState('')
    const [contactSource, setContactSource] = useState('Twin Towers Website')
    const [contactEnquiry, setContactEnquiry] = useState('General Query')
    const [contactToken, setContactToken] = useState('r!AWs1gRgQQS?P4LKB/XMfXeN3T8XHjxrCJxJLDwwTKBxLluLRpdkigSGOWJo9QG')
    const [contactSubject, setContactSubject] = useState('')
    const [contactMessage, setContactMessage] = useState('')

    const [alertBanner, setAlertBanner] = useState(null)

    function handleForm(e) {
        e.preventDefault()

        // if (honey.length >= 1) {
        //     return
        // }

        let body = {
            name: contactName,
            email: contactEmail,
            phone: contactPhone,
            source: contactSource,
            enquiryType: contactEnquiry,
            subject: contactSubject,
            message: contactMessage,
            token: contactToken
            // website: honey,
        }

        fetch(
            `${location.origin}/api/contactus`,
            {
                method: 'POST',
                body: JSON.stringify(body)
            }
        )
            .then(response => {

                if (response.status >= 300) {
                    setAlertBanner({
                        message: response.statusText,
                        type: 'error'
                    })

                    return;
                }

                setAlertBanner({
                    message: response.statusText,
                    type: 'success'
                })

                console.debug('response')
                console.debug(response);
            })
            .catch(error => {

                setAlertBanner({
                    message: response.statusText,
                    type: 'error'
                });

                console.debug('error')
                console.error(error)
            })
    }

    return (
        <>
            <form className={`${styles.contact_from} row`} onSubmit={handleForm}>
                <div className='col-md-6'>
                    <input id="name"
                        type="text"
                        name="name"
                        onChange={e => setContactName(e.target.value)}
                        value={contactName}
                        required
                        className={styles.form_control}
                        placeholder="Full Name" />
                </div>
                <div className='col-md-6'>
                    <input
                        id="email"
                        name="email"
                        type="email"
                        onChange={e => setContactEmail(e.target.value)}
                        value={contactEmail}
                        required
                        className={styles.form_control} placeholder="Email" />
                </div>
                <div className='col-md-6'>
                    <input
                        id="phone"
                        required
                        name="phone"
                        type="number"
                        onChange={e => setContactPhone(e.target.value)}
                        value={contactPhone}
                        className={styles.form_control}
                        placeholder="Phone No"
                    />
                </div>
                <input
                    id="source"
                    required
                    name="source"
                    type="hidden"
                    value={contactSource}
                    className="form-control"
                />
                <input
                    id="enquiryType"
                    required
                    name="enquiryType"
                    type="hidden"
                    value={contactEnquiry}
                    className="form-control"
                />
                <input
                    id="token"
                    required
                    name="token"
                    type="hidden"
                    value={contactToken}
                    className="form-control"
                />
                <div className='col-md-6'>
                    <input
                        id="subject"
                        name="subject"
                        onChange={e => setContactSubject(e.target.value)}
                        value={contactSubject}
                        required
                        className={styles.form_control} placeholder="Subject" />
                </div>
                <div className='pb-2'>
                    <textarea id="message"
                        name="message"
                        onChange={e => setContactMessage(e.target.value)}
                        value={contactMessage}
                        required
                        className={styles.from_textarea} rows="4"
                        placeholder="Message"
                    ></textarea>
                </div>
                <div className={`${styles.submit_btn} col-md-6 col-sm-12`}>
                    <button htmlFor="contactUsForm" type="submit" className="common_btn">Submit</button>
                </div>
                {alertBanner !== null ? <Alert {...alertBanner} /> : null}
            </form>
        </>
    );
}
export default Contactusform;
